import { create } from "zustand";

interface ApiData {
  title?: string;
  canonical?: string;
  metaTags?: { name?: string; content?: string; property?: string; charset?: string }[];
  textContent?: string;
}

interface ApiResponse {
  success: boolean;
  message: string;
  data: ApiData;
}

interface KeywordState {
  keywordsCache: { [key: string]: string[] };
  urlCache: { [key: string]: ApiResponse };
  setKeywords: (text: string, filter: "short" | "long", keywords: string[]) => void;
  getKeywords: (text: string, filter: "short" | "long") => string[] | undefined;
  setUrlResponse: (url: string, response: ApiResponse) => void;
  getUrlResponse: (url: string) => ApiResponse | undefined;
}

export const useKeywordStore = create<KeywordState>((set, get) => ({
  keywordsCache: {},
  urlCache: {},
  setKeywords: (text, filter, keywords) => {
    const key = `${text}-${filter}`;
    set((state) => ({
      keywordsCache: { ...state.keywordsCache, [key]: keywords },
    }));
  },
  getKeywords: (text, filter) => {
    const key = `${text}-${filter}`;
    return get().keywordsCache[key];
  },
  setUrlResponse: (url, response) => {
    set((state) => ({
      urlCache: { ...state.urlCache, [url]: response },
    }));
  },
  getUrlResponse: (url) => {
    return get().urlCache[url];
  },
}));